import Mixin from '@/mixin';

export type ReportType = 'overall' | 'department' | 'individual'
export type ReportParam = {
  startDate: string;
  endDate: string;
  reportType: ReportType;
  reportPeriod: string;
  department: string;
  coachId: string;
  company: string;
};

class ReportViewModel extends Mixin {
  private _startDate: string = '';
  private _endDate: string = '';
  private _reportPeriod: string = 'all';
  private _reportType: ReportType = 'overall';
  private _department: string = '';
  private _coachId: string = '';
  private _company: string = '';

  get startDate(): string {
    return this._startDate;
  }

  set startDate(value: string) {
    this._startDate = value;
    window.sessionStorage.setItem('REPORT_FROM_DATE', value);
  }

  get endDate(): string {
    return this._endDate;
  }

  set endDate(value: string) {
    this._endDate = value;
    window.sessionStorage.setItem('REPORT_TO_DATE', value);
  }

  get reportPeriod(): string {
    return this._reportPeriod;
  }

  get reportType(): 'overall' | 'department' | 'individual' {
    return this._reportType;
  }

  get department(): string {
    return this._department;
  }

  get coachId(): string {
    return this._coachId;
  }

  set coachId(value: string) {
    this._coachId = value;
  }

  get company(): string {
    return this._company;
  }

  set company(value: string) {
    this._company = value;
  }

  initReportParams(params: Partial<ReportParam>) {
    if (params.startDate) {
      this._startDate = params.startDate;
    }
    if (params.endDate) {
      this._endDate = params.endDate;
    }
    if (params.coachId) {
      this._coachId = params.coachId;
    }
    if (params.company) {
      this._company = params.company;
    }
    if (params.department) {
      this._department = params.department;
    }
    if (params.reportPeriod) {
      this._reportPeriod = params.reportPeriod;
    }
    if (params.reportType) {
      this._reportType = params.reportType;
    }
  }

  loadReportParamInLocal() {
    const startDate = window.sessionStorage.getItem('REPORT_FROM_DATE') ?? '';
    const endDate = window.sessionStorage.getItem('REPORT_TO_DATE') ?? '';
    const coachId = window.sessionStorage.getItem('REPORT_MANAGER_ID') ?? '';
    const company = window.sessionStorage.getItem('REPORT_COMPANY') ?? '';
    const department = window.sessionStorage.getItem('REPORT_DEPARTMENT') ?? '';
    const reportPeriod = window.sessionStorage.getItem('REPORT_PERIOD') ?? '';
    const reportType = window.sessionStorage.getItem(
      'REPORT_TYPE'
    ) as ReportType;

    this.initReportParams({
      startDate,
      endDate,
      coachId,
      company,
      department,
      reportPeriod,
      reportType,
    });
  }

  loadReportParamsInURI() {
    const queries = this.decodingURLQueries();
    const {
      coachId = '',
      type = '',
      fromDate = '',
      toDate = '',
      department = '',
      companyName = '',
    } = queries;
    const param: ReportParam = {
      startDate: fromDate,
      endDate: toDate,
      reportType: type,
      department,
      coachId,
      company: companyName,
      reportPeriod: '',
    };

    this.initReportParams(param);
  }

  shouldReloadParam(): boolean {
    if (this.reportType === 'individual' && !this.coachId) return true;
    if (this.reportType === 'department' && !this.department) return true;

    return !this.company || !this.reportType || !this.startDate || !this.endDate;
  }

  loadReportParams() {
    if (this.shouldReloadParam()) {
      this.loadReportParamInLocal();
    }
    if (this.shouldReloadParam()) {
      this.loadReportParamsInURI();
    }
  }

  clean() {
    this._startDate = '';
    this._endDate = '';
    this._reportPeriod = '';
    this._department = '';
    this._coachId = '';
    this._company = '';
    this._reportType = 'overall';
  }
}

const reportViewModel = new ReportViewModel();
export default reportViewModel; 